<div class="content" fxLayout="column" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="16px" [@routeAnimation]="true">
    <mat-card style="background: #f7f7f7;">
        <mat-tab-group #tabGroup mat-stretch-tabs (selectedTabChange)="onTabChange($event.index)">

            <mat-tab label="Charitable Contributions">
                <div style="padding: 15px;" *ngIf="tabGroup.selectedIndex === 0">
                    <button mat-raised-button color="primary" (click)="editExpOrgListCC()">Edit Exp-Org List</button>
                </div>
                <accDist-table-component *ngIf="tabGroup.selectedIndex === 0" [data]='expOrgCCDetails' [isLoading]='isLoadingExpOrgDetails'>
                </accDist-table-component>
            </mat-tab>

            <mat-tab label="Community Investment/ Community Grants">
                <div style="padding: 15px;" *ngIf="tabGroup.selectedIndex === 1">
                    <button mat-raised-button color="primary" (click)="editExpOrgListCI()">Edit Exp-Org List</button>
                </div>
                <!-- <div class="userHeading">
                        Selected Company List
                </div> -->
                <accDist-table-component *ngIf="tabGroup.selectedIndex === 1" [data]='expOrgCIDetails' [isLoading]='isLoadingExpOrgDetails'>
                </accDist-table-component>
            </mat-tab>

            <mat-tab label="Plant for the Planet">
                <div style="padding: 15px;" *ngIf="tabGroup.selectedIndex === 2">
                    <button mat-raised-button color="primary" (click)="editExpOrgListPFTP()">Edit Exp-Org List</button>
                </div>
                <accDist-table-component *ngIf="tabGroup.selectedIndex === 2" [data]='expOrgPPDetails' [isLoading]='isLoadingExpOrgDetails'>
                </accDist-table-component>
            </mat-tab>
        </mat-tab-group>
    </mat-card>
</div>


<!-- <div class="content" fxLayout="column" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="16px" [@routeAnimation]="true">

    <button mat-raised-button color="primary" (click)="editExpOrgList()">Edit Exp-Org List</button>
    <mat-card>
        <h4>Selected Exp-Org List</h4>
        <div class="cc-forms-container">
            <div class="cc-form-loading-shade" *ngIf="isLoadingExpOrgDetails">
                <mat-spinner *ngIf="isLoadingExpOrgDetails"></mat-spinner>
            </div>

            <mat-table class="mat-elevation-z8" #table [dataSource]="dataSource" matSort>
                <ng-container matColumnDef="code">
                    <mat-header-cell style="flex-grow: 1;" *matHeaderCellDef mat-sort-header> Code </mat-header-cell>
                    <mat-cell style="flex-grow: 1;" *matCellDef="let row"> {{row.code}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="description">
                    <mat-header-cell style="flex-grow: 3;" *matHeaderCellDef mat-sort-header> Description </mat-header-cell>
                    <mat-cell style="flex-grow: 3;" *matCellDef="let row"> {{row.descr}} </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>

        </div>
    </mat-card>
</div> -->